const Configuration = {};
fetch("/configuration.json").then(response => response.json()).then(data => {
  Object.assign(Configuration, data);
}).catch(() => ({}));
export default Configuration;